<template>
  <section class="views">
    <headers></headers>
    <div class="views_content">
      <div class="views_banner">
        <img :src="require('@/assets/image/hodgepodge/h5banner.jpg')" alt="" />
      </div>

      <div class="views_uls">
        <div class="back_box_uls">
          <div class="backUls_box">
            <div class="ulstitle">
              <img
                :src="require('@/assets/image/hodgepodge/title1.png')"
                alt=""
              />
            </div>

            <div class="uls_list">
              <div class="organizersMessage">
                <div v-for="(item, index) in sponsorIcon" :key="index">
                  <div class="title_left">
                    <span v-if="index === 0">主辦機構：</span>
                  </div>
                  <img :src="item.img" alt="" />
                  <div class="text">{{ item.alt }}</div>
                </div>
              </div>
              <div class="posters_text">
                <ul>
                  <!-- <li>
                    <div class="posters_text_left">主辦機構：</div>
                    <div class="posters_text_right">曾憲備慈善基金、新界校長會、中文路（香港）有限公司</div>
                  </li> -->
                  <li v-for="(item, index) in sponsorArr" :key="index">
                    <div class="posters_text_left">
                      {{ item.leftValue }}
                      <div
                        style="
                          font-size: 12px;
                          color: #666666;
                          font-weight: 400;
                        "
                      >
                        {{ item.leftText }}
                      </div>
                    </div>
                    <div class="posters_text_right">{{ item.rightValue }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="backUls_box2" ref="timeSlide">
            <div class="timeBox">
              <div
                class="timeBox_list"
                v-for="(item, index) in competitionTimeLine"
                :key="index"
                :ref="`tab${index}Ref`"
              >
                <div v-if="item.xuanSelect" style="display: flex" id="target">
                  <span class="selectTime" @click="stageBut(index)"
                    >當前階段</span
                  >
                </div>

                <strong v-else>
                  <span
                    :class="item.select ? 'select' : 'selectdefault'"
                    class="timeBox_dian"
                    @click="stageBut(index)"
                  ></span>
                </strong>

                <div
                  class="timeBox_top"
                  :class="!item.select ? '' : 'timeBox_topselect'"
                  @click="stageBut(index)"
                >
                  <!-- <span v-if="!item.select"> {{ item.name }}</span> -->
                  <img
                    :src="
                      require('@/assets/image/qp/' +
                        (item.index || index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>

                <div class="timeBox_bottom" @click="stageBut(index)">
                  <strong v-html="item.tiem"> </strong>
                </div>
              </div>
            </div>
          </div>
          <!-- 参数资格 -->
          <div class="backUls_box4">
            <div class="backUls_box4_content">
              <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title2.png')"
                  alt=""
                />
              </div>
              <div class="backUls_box4_nr">
                <div class="backUls_box4_nr_list">
                  <div style="text-align: left; font-weight: 600">
                    （一）參賽資格
                  </div>
                  <ul style="margin: 0.15rem">
                    <li
                      v-for="(item, index) in competitionQualifying.info"
                      :key="index"
                      v-html="item"
                    ></li>
                  </ul>
                </div>
                <div class="backUls_box4_nr_list" style="margin-bottom: 0">
                  <div style="text-align: left; font-weight: 600">
                    （二）組別
                  </div>
                  <div class="cszg_table isChinese">
                    <table class="table-wrap">
                      <thead>
                        <tr>
                          <th colspan="2">幼稚園</th>
                          <th colspan="3">小學</th>
                          <th>中學</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>初級組<br />K1-K2</td>
                          <td>高級組<br />K3</td>
                          <td>初級組<br />P1-P2</td>
                          <td>中級組<br />P3-P4</td>
                          <td>高級組<br />P5-P6</td>
                          <td>中學組<br />S1-S6</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="cszg_table">
                    <table class="table-wrap">
                      <thead>
                        <tr>
                          <th colspan="3">非華裔</th>
                          <th>特殊學校</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>飛躍-幼稚園組</td>
                          <td>飛躍-小學組</td>
                          <td>飛躍-中學組</td>
                          <td>閃亮組</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 參賽須知 -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title5.png')"
                  alt=""
                />
              </div>
              <div class="backUls_box5_nr">
                <div class="backUls_box5_nr_title">報名方法</div>

                <div class="backUls_box5_nr_content_2">
                  <table class="bxxq-table-wrap">
                    <tbody>
                      <tr>
                        <td rowspan="2">個人學生</td>
                        <td colspan="2">
                          <div>網頁報名</div>
                          <div>
                            <span class="link_not_allowed"
                              >報名已結束</span
                            >
                            <!-- <span
                              class="show-link"
                              @click="$router.push('/signup')"
                              >立即登記</span
                            > -->
                          </div>
                        </td>
                        <td colspan="2">
                          <div>App報名</div>
                          <div>
                            <!-- <span class="link_not_allowed" title="暫未開放報名"
                              >立即下載</span
                            > -->
                            <a
                              class="show-link"
                              href="https://app.chineserd.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              >立即下載</a
                            >
                          </div>
                        </td>
                      </tr>
                      <tr v-if="false">
                        <!-- 隐藏1 -->
                        <td>圖1</td>
                        <td>視頻1</td>
                        <td>圖2</td>
                        <td>視頻2</td>
                      </tr>
                      <tr>
                        <td colspan="4" style="text-align: left">
                          <div style="font-weight: 600">*注意：</div>
                          <p>
                            ①
                            個人學生應留意：同一電話號碼僅可用於3位或以下的參賽學生報名。
                          </p>
                          <p>
                            ②
                            中文路之在讀學生，請先更新App，即可在app内完成報名。
                          </p>
                        </td>
                      </tr>
                      <!--  -->
                      <tr>
                        <td
                          rowspan="7"
                          style="
                            font-weight: 600;
                            text-align: center;
                            vertical-align: middle;
                          "
                        >
                          <div style="font-weight: 600">學校報名</div>
                          <div
                            style="
                              font-weight: 400;
                              font-size: 14px;
                              line-height: 20px;
                              padding: 10px 0px;
                            "
                          >
                            <a
                              class="show-link"
                              href="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2026-01/daccda2fadabe0a38034c04797e4953f.pdf"
                              target="_blank"
                            >
                              操作指引
                            </a>
                          </div>
                        </td>
                        <td colspan="2">
                          <div>1.登記學校信息</div>
                          <div>
                            <!-- <span class="link_not_allowed" title="暫未開放報名"
                              >立即登記</span
                            > -->
                            <span class="show-link" @click="goToSchoolInfo()"
                              >立即登記</span
                            >
                          </div>
                        </td>
                        <td colspan="2">
                          <div>2.大會開通並發放賬戶</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <div>3.通過網頁連結登入平台</div>
                          <div>
                            <!-- <span網頁報名 -->
                            <span class="show-link" @click="homeToLogin()"
                              >登入平台</span
                            >
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">4.老師可選以下其中一種方式登記報名</td>
                      </tr>
                      <tr>
                        <td colspan="2" style="text-align: left">
                          <div>方式一：</div>
                          <p>
                            ① 下載報名比賽二維碼（含通告）給學生/家長自行報名；
                          </p>
                        </td>
                        <td colspan="2" style="text-align: left">
                          <div>方式二：</div>
                          <p>① 下載並填寫，然後上載參賽學生表格；</p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="text-align: left">
                          <p>
                            ②
                            學生/家長自行下載中文路App及登入【校園賬戶】參與比賽。
                          </p>
                        </td>
                        <td colspan="2" style="text-align: left">
                          <p>
                            ②
                            通知學生/家長，下載中文路App及登入【校園賬戶】並參與比賽。
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="text-align: left">
                          <div style="font-weight: 600">*注意：</div>
                          <p>掃碼報名截止時間：</p>
                          <div style="color: #f97226; font-weight: 600">
                            2026年3月8日 20:00 前
                          </div>
                        </td>
                        <td colspan="2" style="text-align: left">
                          <div style="font-weight: 600">*注意：</div>
                          <p>學校/機構提交報名表截止時間：</p>
                          <div style="color: #f97226; font-weight: 600">
                            2026年3月4日 20:00 前
                          </div>
                        </td>
                      </tr>
                      <tr v-if="false">
                        <!-- 隐藏1 -->
                        <td>圖1</td>
                        <td>視頻1</td>
                        <td>圖2</td>
                        <td>視頻2</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="backUls_box5_nr_title">報名確認</div>
                <div class="backUls_box5_nr_content_2">
                  <ol>
                    <li>
                      當中文路收妥報名表並審核無誤後，3個工作天內便會向參賽學生發出報名成功確認電郵。參賽學生應細閱電郵內的一切注意事項。
                    </li>
                    <li>
                      請報名的參賽學生時刻留意主辦方的聯絡資訊（包括但不限於：SMS短信、E-mail郵件、電話或WhatsApp等），如錯過主辦方發出的通知資訊所導致的問題主辦方概不負責。
                    </li>
                  </ol>
                </div>

                <div class="backUls_box5_nr_title">注意事項</div>
                <div class="backUls_box5_nr_content_2">
                  <ol>
                    <li>
                      所有比賽階段的表演者必須為參賽學生本人，如審核發現非參賽學生本人錄製或出席現場比賽之情況，將被取消參賽資格，予以失格公示。
                    </li>
                    <li>
                      凡是報名比賽的參賽學生，等同於同意主辦方將其參賽影片使用在不同渠道媒體進行展示宣傳。
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- 比賽階段 -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title3.png')"
                  alt=""
                />
              </div>
              <div class="backUls_box5_nr">
                <table class="guidance-table-wrap">
                  <tbody>
                    <tr>
                      <td rowspan="5" style="font-weight: 600; width: 28px">
                        初賽
                      </td>
                      <td colspan="4">
                        <p>以中文路App： AI 語音評測系統進行海選</p>
                        <p style="font-weight: 600">
                          每位參賽學生有5次參賽機會
                        </p>
                        <span
                          >*參賽學生可於【我要練習】板塊中，不限次數練習，請注意練習成績僅供參考。</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align: left">
                        <div class="app_login">
                          登入App：<img
                            src="@/assets/image/icon/logo_app.png"
                            alt=""
                          /><span style="font-weight: 600">ChineseRd Plus</span>
                        </div>
                        <div>
                          <span style="font-weight: 600">下載連結：</span
                          ><a
                            class="show-link"
                            href="https://app.chineserd.com/"
                            target="_blank"
                            >https://app.chineserd.com/</a
                          >
                        </div>
                      </td>
                      <td colspan="2">
                        <img
                          style="max-width: 2.8rem"
                          src="@/assets/image/app_chineserd.png"
                          alt=""
                        />
                        <div style="font-size: 0.28rem">
                          掃描 QR Code 下載App
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div>
                          <p style="font-weight: 600">學生</p>
                          <p>自行報名</p>
                        </div>
                      </td>
                      <td colspan="2">
                        <div>
                          <p style="font-weight: 600">學校</p>
                          <p>集體報名</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="guide-thumb">
                          <img
                            :src="require('@/assets/image/Personal_guide.jpg')"
                            alt="指引圖1"
                            @click="
                              handleShowGuide(
                                'img',
                                require('@/assets/image/Personal_guide.jpg')
                              )
                            "
                          />
                        </div>
                      </td>
                      <!-- <td>視頻1</td> -->
                      <td colspan="2">
                        <div class="guide-thumb">
                          <img
                            :src="require('@/assets/image/school_guide.jpg')"
                            alt="指引圖2"
                            @click="
                              handleShowGuide(
                                'img',
                                require('@/assets/image/school_guide.jpg')
                              )
                            "
                          />
                        </div>
                      </td>
                      <!-- <td>視頻2</td> -->
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p style="font-weight: 600; color: #3e7eec">
                          每完成1次語音評測，參賽學生即獲1次抽獎機會（最高5次）
                        </p>
                        <div>
                          <a
                            class="show-link"
                            href="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/dc1cb7a1213a86b6e868e4daf7979ec3.pdf"
                            target="_blank"
                            >抽獎細則</a
                          >
                        </div>
                      </td>
                    </tr>
                    <!-- 复赛 -->
                    <tr>
                      <td rowspan="1" style="font-weight: 600">複賽</td>
                      <td colspan="4">
                        <p>錄製朗誦影片，</p>
                        <p>並在 網頁 或 中文路App提交</p>
                      </td>
                    </tr>
                    <tr v-if="false">
                      <!-- 隐藏1 -->
                      <td colspan="2">
                        <div>
                          <p>網頁提交</p>
                        </div>
                      </td>
                      <td colspan="2">
                        <div>
                          <p>App提交</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="false">
                      <!-- 隐藏1 -->
                      <td>圖1</td>
                      <td>視頻1</td>
                      <td>圖2</td>
                      <td>視頻2</td>
                    </tr>
                    <!-- 决赛 -->
                    <tr>
                      <td rowspan="4" style="font-weight: 600">決賽</td>
                      <td colspan="4">
                        <div>
                          將於<span style="font-weight: 600">
                            東華三院曾憲備小學 </span
                          >進行<span style="font-weight: 600; color: #3e7eec"
                            >現場比賽</span
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">選出金獎、銀獎、銅獎、優異獎</td>
                    </tr>
                    <tr>
                      <td colspan="4">最佳造型獎、最佳語音獎、最佳台風獎</td>
                    </tr>
                    <tr>
                      <td colspan="4">優秀指導老師獎</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 參賽獎項 -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title6.png')"
                  alt=""
                />
              </div>

              <div class="awards-box">
                <table class="awards-table-wrap">
                  <tbody>
                    <tr>
                      <td style="font-weight: 600">電子證書</td>
                      <td>
                        <img
                          src="@/assets/image/home_images/01_Participation_Certificate.png"
                          alt=""
                        />
                        <div>參賽證明</div>
                      </td>
                      <td>
                        <img
                          src="@/assets/image/home_images/02_Shortlist_Notification.png"
                          alt=""
                        />
                        <div>入圍證明</div>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="font-weight: 600">獎項</td>
                      <td class="award-item">
                        <img
                          src="@/assets/image/home_images/03_Gold_Award.png"
                          alt=""
                        />
                        <div>金獎 獎杯<br />現金獎金$2,000<br />證書</div>
                      </td>
                      <td class="award-item">
                        <img
                          src="@/assets/image/home_images/04_Silver_Award.png"
                          alt=""
                        />
                        <div>銀獎 獎杯<br />現金獎金$1,000<br />證書</div>
                      </td>
                      <td class="award-item">
                        <img
                          src="@/assets/image/home_images/05_Bronze_Award.png"
                          alt=""
                        />
                        <div>銅獎 獎杯<br />現金獎金$800<br />證書</div>
                      </td>
                      <td class="award-item">
                        <img
                          src="@/assets/image/home_images/06_Excellence_Award.png"
                          alt=""
                        />
                        <div>優異獎<br />獎牌<br />證書</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-weight: 600">特色獎項</td>
                      <td colspan="4" style="font-weight: 600">
                        最佳造型獎、最佳語音獎、最佳台風獎、優秀指導老師獎、積極參與學校獎、傑出表現學校獎
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="table-tips">*獎金發放安排請留意官方公告。</div>
              </div>
            </div>
          </div>

          <!-- 比赛详情  -->
          <div class="backUls_box5">
            <div class="backUls_box5_content">
              <div class="ulstitle">
                <img
                  :src="require('@/assets/image/hodgepodge/title4.png')"
                  alt=""
                />
              </div>
              <div class="backUls_box5_nr">
                <div class="backUls_box5_nr_title">比賽誦材</div>
                <div class="backUls_box5_nr_content_2">
                  <ul>
                    <li>參賽學生可在中文路App內不限次數練習參賽誦材。</li>
                  </ul>
                  <div class="table-tips" style="margin-bottom: 10px">
                    *參賽學生可自選參賽組別之推薦誦材集內的不同篇章，參與各比賽階段。
                  </div>
                  <div class="a_view" @click="socai()">點擊下載 比賽誦材</div>
                </div>

                <table class="materials-table-wrap">
                  <tbody>
                    <tr>
                      <td style="font-weight: 600">組別</td>
                      <td>
                        <div style="font-weight: 600">誦材類型</div>
                        <div>內容以歌頌中華文化經典為主</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>幼稚園初級組</div>
                        <div>（K1-K2）</div>
                      </td>
                      <td rowspan="2">
                        <div>童詩、古詩</div>
                        <div>（兒歌、繞口令）</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>幼稚園高級組</div>
                        <div>（K3）</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>小學初級組</div>
                        <div>（P1-P2）</div>
                      </td>
                      <td rowspan="2">古诗、童诗、新诗</td>
                    </tr>
                    <tr>
                      <td>
                        <div>小學中級組</div>
                        <div>（P3-P4）</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>小學高級組</div>
                        <div>（P5-P6）</div>
                      </td>
                      <td rowspan="2">新詩、散文、古文</td>
                    </tr>
                    <tr>
                      <td>
                        <div>中學組</div>
                        <div>（S1-S6）</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>飛躍組</div>
                        <div>（幼稚園、小學、中學）</div>
                      </td>
                      <td>散文、古詩</td>
                    </tr>
                    <tr>
                      <td>
                        <div>閃亮組</div>
                        <div>（特殊學校）</div>
                      </td>
                      <td>古詩</td>
                    </tr>
                  </tbody>
                </table>
                <!--  -->
                <div class="backUls_box5_nr_title">比賽章程</div>
                <div class="backUls_box5_nr_content_2">
                  <div class="a_view" @click="zhangcheng()">
                    點擊下載 比賽章程
                  </div>
                </div>

                <div class="backUls_box5_nr_title">評分標準</div>

                <div class="score-box">
                  <div class="left-title">1.初賽（AI語音評測）</div>
                  <div class="table-tips" style="margin-top: 10px">
                    *請注意初賽僅考察讀音準確性。
                  </div>
                  <table class="table-wrap" style="margin-top: 10px">
                    <thead>
                      <tr>
                        <th style="width: 26%">評判標準</th>
                        <th>內容説明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="3">語音（85%）</td>
                        <td style="text-align: left">聲調（25%）</td>
                      </tr>
                      <tr>
                        <td style="text-align: left">聲母（30%）</td>
                      </tr>
                      <tr>
                        <td style="text-align: left">韻母（30%）</td>
                      </tr>
                      <tr>
                        <td>流暢（5%）</td>
                        <td style="text-align: left">流暢度（5%）</td>
                      </tr>
                      <tr>
                        <td>完整（10%）</td>
                        <td style="text-align: left">
                          完整度（10%）：完整朗讀指定篇目
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="left-title">2. 複賽（錄影）</div>
                  <table class="table-wrap">
                    <thead>
                      <tr>
                        <th style="width: 26%">評判標準</th>
                        <th>內容説明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">語音（30分）</td>
                        <td style="text-align: left">
                          普通話發音（20分）：聲母、韻母、聲調、吐字清晰。每處錯誤扣0.5或1分。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          節奏韻律（10分）：語速恰當、斷句準確、停連得當。每處錯誤扣0.5或1分。
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="3">儀態面貌（10分）</td>
                        <td style="text-align: left">服飾大方得體（3分）</td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          舉止從容，大方有感染力（3分）
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">頭尾問好、答謝（4分）</td>
                      </tr>
                      <tr>
                        <td rowspan="6">誦材處理（60分）</td>
                        <td style="text-align: left">
                          肢體動作（10分）：配以適當的動作和手勢或增加創意部分，完全無動作或肢體語言扣5分。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          感情處理（15分）：富有感情、有感染力、充分表達誦材的情感、抑揚頓挫、渲染氣氛。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          表現力（15分）：聲音洪亮、眼神、表情準確自然、活潑生動。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          內容把握（10分）：誦材基調把握到位、傳遞正確主旨。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          誦材完成度（10分）：表演自然流暢，文章熟悉，全文背誦。
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="table-tips" style="margin-top: 10px">
                    *最終評分解釋權為比賽評審團所屬。
                  </div>
                  <div class="left-title">3.決賽（現場）</div>
                  <table class="table-wrap">
                    <thead>
                      <tr>
                        <th style="width: 26%">評判標準</th>
                        <th>內容説明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">語音（30分）</td>
                        <td style="text-align: left">
                          普通話發音（20分）：<br />聲母、韻母、聲調、吐字清晰。每處錯誤扣0.5或1分。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          節奏韻律（10分）：<br />語速恰當、斷句準確、停連得當。每處錯誤扣0.5或1分。
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2">儀態面貌（10分）</td>
                        <td style="text-align: left">
                          服裝造型乾淨整潔（3分）
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          舉止從容，得體大方（7分）
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="6">誦材處理（60分）</td>
                        <td style="text-align: left">
                          肢體動作（10分）：<br />配以適當的動作和手勢或增加創意部分，完全無動作或肢體語言扣5分。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          感情處理（15分）：<br />富有感情、有感染力、充分表達誦材的情感、抑揚頓挫、渲染氣氛。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          表現力（15分）：<br />聲音洪亮、眼神、表情準確自然、活潑生動。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          內容把握（10分）：<br />誦材基調把握到位、傳遞正確主旨。
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: left">
                          誦材完成度（10分）：<br />表演自然流暢，文章熟悉，全文背誦。
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="table-tips" style="margin-top: 0px">
                    *最終評分解釋權為比賽評審團所屬。
                  </div>
                  <div class="table-tips">
                    *主辦方保留對比賽流程安排及比賽相關章程的最終解釋權。如有任何爭議，主辦方保留一切最終決定權。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="backUls_box6"></div>
        </div>
      </div>

      <!-- <div class="fontBottom" @click="baoming()">
        <span>在線報名</span>
      </div> -->
      <!-- <div
        class="fontBottom"
        @click="handleUploadVideo()"
      >
        <span>上載複賽影片</span>
      </div> -->
      <!-- <div class="fontBottom">
        <span>複賽結束</span>
      </div> -->
    </div>
    <!-- 复赛资料视频上传-->
    <van-popup
      v-model="datumZZC"
      :close-on-click-overlay="false"
      :closeable="true"
      :round="true"
      :lock-scroll="false"
    >
      <div class="datumBox">
        <div class="titleH1">
          <div class="left_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="title">上載參賽影片</div>
          <div class="right_icon">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="stepBox">
          <div class="stepUls">
            <div
              class="xian"
              :class="stepActive >= 1 ? 'active2' : 'active'"
            ></div>
            <div
              class="xian"
              :class="stepActive >= 2 ? 'active2' : 'active'"
            ></div>
          </div>

          <ul>
            <li
              v-if="chooseFrom == 0"
              v-for="(item, index) in 3"
              :class="stepActive >= index ? 'active' : ''"
              :key="index"
            ></li>
            <li
              v-if="chooseFrom == 1"
              v-for="(item, index) in 2"
              :class="stepActive >= index ? 'active' : ''"
              :key="index"
            ></li>
          </ul>
        </div>
        <div class="stepText">
          <div :class="stepActive >= 0 ? 'active' : ''">登錄</div>
          <div v-if="chooseFrom == 0" :class="stepActive >= 1 ? 'active' : ''">
            完善資料
          </div>
          <div :class="stepActive >= 2 ? 'active' : ''">上載影片</div>
        </div>

        <div class="datumCentent" v-if="stepActive == 0">
          <div class="tab">
            <div class="prompt" style="margin-bottom: 12px">
              <div
                :class="chooseFrom == 0 ? 'highlight' : ''"
                @click="datumYZ(0)"
              >
                個人報名
              </div>
              <div
                :class="chooseFrom == 1 ? 'highlight' : ''"
                @click="datumYZ(1)"
              >
                學校報名
              </div>
            </div>
            <template v-if="chooseFrom == 0">
              <div class="row-input">
                <!-- <div class="input-name" style="width: 22%; padding: 0">
                  參賽電話
                </div> -->
                <div class="promptInput2">
                  <div class="lis">
                    <div class="lisLife">
                      <!-- <img :src="require('@/assets/image/hk.png')" />
									<span>+852</span> -->
                      <CountryCodeSelector
                        :searchbar="false"
                        :countryCode.sync="prefix"
                        style="width: 90px; margin-right: 15px"
                      ></CountryCodeSelector>
                    </div>
                    <div class="lisRight">
                      <input
                        type="text"
                        placeholder="請輸入參賽電話"
                        value=""
                        v-model.trim="from2.phone"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row-input">
                <!-- <div class="input-name" style="width: 22%; padding: 0">
                  參賽姓名
                </div> -->
                <div class="promptInput">
                  <input placeholder="請輸入參賽者姓名" v-model="from2.name" />
                </div>
              </div>
            </template>
            <template v-if="chooseFrom == 1">
              <div class="row-input">
                <!-- <div class="input-name">學校編號</div> -->
                <div class="promptInput">
                  <input
                    placeholder="請輸入學校編號"
                    v-model.trim="from2.schoolCode"
                  />
                </div>
              </div>
              <div class="row-input">
                <!-- <div class="input-name">學生編號</div> -->
                <div class="promptInput">
                  <input
                    placeholder="請輸入登入編號"
                    v-model.trim="from2.studentCode"
                  />
                </div>
              </div>
              <div class="row-input">
                <div class="promptInput">
                  <input placeholder="請輸入參賽者姓名" v-model.trim="from2.name" />
                </div>
              </div>
              <!-- <div class="row-input">
                <div class="input-name">學生密碼</div>
                <div class="promptInput">
                  <input
                    placeholder="請輸入學生密碼"
                    v-model.trim="from2.password"
                  />
                </div>
              </div> -->
            </template>
          </div>
          <div class="tabTis_1">
            提交遇到問題？點擊右側按鈕聯系我們
            <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div class="view_guide" @click="isRematch = true">查看複賽指引</div>
          <div class="but" @click="datumActiveBut ? datumBut(0) : ''">
            下一步
          </div>
        </div>

        <div class="datumCentent" v-if="stepActive == 1">
          <div class="tab">
            <div class="prompt" v-show="schollName == null">就讀學校</div>
            <div
              class="promptInput"
              style="width: 100%"
              v-show="schollName == null"
            >
              <input placeholder="請輸入就讀學校" v-model="from2.school_name" />
            </div>
            <div class="prompt">
              證件上傳
              <span>&nbsp;帶照片學生證/身份證明</span>
            </div>
            <div class="promptInput3">
              <uploaderCent
                @uploaderChange="uploaderImageChange"
                accept="image/*"
                uploadText="點擊上傳"
                logoaAtive="0"
              ></uploaderCent>
            </div>
          </div>

          <div class="tabTis">
            提交遇到問題？點擊右側按鈕聯系我們
            <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div class="but" @click="datumBut(1)">下一步</div>
          <!-- <div class="but2" @click="getBack()">返回上一步</div> -->
        </div>

        <div class="datumCentent" v-if="stepActive == 2">
          <div class="tab">
            <div class="promptInput3">
              <uploaderCent
                @uploaderChange="uploaderVideoChange"
                accept="video/*"
                uploadText="點擊上載影片"
                v-if="wonderful == false"
                logoaAtive="1"
              ></uploaderCent>
              <!-- 上傳影片成功后顯示預覽按鈕 -->
              <div class="videoYulan" v-if="videoYL">
                <div class="guanbu" @click="videoYLBut">X</div>
                <video controls :autoplay="true" :src="videoUrl"></video>
              </div>
              <div
                class="videoYulan2"
                style="cursor: pointer"
                v-if="from2.video != null && wonderful == false"
                @click="videoYLBut"
              >
                <span style="color: #000000 !important; margin-right: 10px"
                  >影片已成功上載</span
                >點擊預覽視頻
              </div>
              <!-- 點擊預覽視頻  @click="videoYLBut"-->
              <!-- <div class="videoYulan2" v-if="from2.video && wonderful == false" @click="videoYLBut">影片已成功上載</div>-->
              <div class="wonderful" v-if="wonderful == true">
                <img src="@/assets/image/fusai/ludui.png" />
                恭喜你，成功上載影片，請耐心等待評審結果
              </div>
            </div>
          </div>
          <div class="tabTis" v-if="wonderful == false">
            提交遇到問題？點擊右側按鈕聯系我們
            <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
              ><img src="@/assets/image/fusai/whatsapp.png"
            /></a>
          </div>
          <div
            class="but"
            v-if="wonderful == false"
            @click="datumActiveBut ? submit() : ''"
          >
            提交
          </div>
          <div class="but" v-if="wonderful == true" @click="wonderfulBut">
            我知道了
          </div>
          <!-- <div class="but2" v-if="wonderful==false" @click="getBack()">返回上一步</div> -->
        </div>
      </div>
    </van-popup>
    <!-- 未入圍/成功入園 -->
    <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false">
      <div class="newShortBox">
        <div class="list" v-if="newShortActive == 1">
          <!-- <div class="lis lisCenten"> <van-image width="149px" :src="require('@/assets/image/fusai/yes.png')" /> </div> -->
          <div class="ulst">
            <ul>
              <li>姓名</li>
              <li>組別</li>
              <li>分數</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText">
            恭喜您，成功入圍複賽，請仔細閱讀入圍電郵，上載參賽視頻。
          </div>
          <!-- <div class="but" @click="handelGuide">點擊查看複賽指引</div> -->
        </div>

        <div class="list" v-if="newShortActive == 2">
          <div class="ulst">
            <ul>
              <li>姓名</li>
              <li>組別</li>
              <li>分數</li>
            </ul>
            <ul>
              <li>
                {{ userObj.studentName == null ? "" : userObj.studentName }}
              </li>
              <li>
                {{
                  userObj.competitionGroup == null
                    ? ""
                    : userObj.competitionGroup
                }}
              </li>
              <li>{{ userObj.score == null ? "" : userObj.score }}</li>
            </ul>
          </div>
          <div class="lis lisText">
            很遺憾，您的成績未能入圍複賽，非常感謝您的參與
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="showGuide"
      :show-close-button="false"
      :close-on-click-overlay="true"
      width="90%"
      z-index="99999"
      confirm-button-text="關 閉"
    >
      <div class="image-container" v-if="showType == 'img'">
        <van-image width="100%" :src="guideUrl" fit="contain" />
      </div>
      <div class="image-container" v-if="showType == 'video'">
        <video width="100%" controls :autoplay="true" :src="guideUrl"></video>
      </div>
    </van-dialog>
    <!-- 複賽指引 -->
    <RematchModal
      style="z-index: 9999"
      v-if="isRematch"
      @cancel="isRematch = false"
    ></RematchModal>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import uploaderCent from "@/components/uploaderBox/index.vue";
import CountryCodeSelector from "@/components/CountryCodeSelector";
import RematchModal from "@/components/rematchModal/index.vue";
import { speecheduUrl } from "@/utils/link";

export default {
  name: "views",
  components: {
    headers,
    uploaderCent,
    CountryCodeSelector,
    RematchModal,
  },
  data() {
    return {
      datumZZC: false, // 上传视频弹窗控制
      stepActive: 0, //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
      datumActiveBut: true, //防止連續點擊
      wonderful: false, //成功
      videoYL: false, //預覽
      chooseFrom: 0, //驗證
      from2: {
        name: null, //名字
        school_name: null, //学校
        email: null, //邮箱
        phone: null, //手机
        certificate: null, //证件
        video: null, //视频
      },
      schollName: null, //控制学校是否显示
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1, //1是成功  2是失敗
      choose: 0, //查詢的下標
      from: {
        school_name: null,
        email: null,
        phone: null,
      },
      finalistsBut: true, //防止連續點擊
      userObj: {
        competitionGroup: 1, //組別
        score: null, //分數
        studentName: null, //名字
      },
      prefix: "852",
      showGuide: false,
      showType: "",
      guideUrl: "",
      isRematch: false,
    };
  },
  computed: {},
  mixins: [publics, home],
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.uploadVideo) {
      this.datumZZC = true;
      this.$router.replace({ query: { uploadVideo: false } });
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initScroll(); // 时间轴居中
      }, 1500);
    });
  },
  methods: {
    goToSchoolInfo() {
      let url = "https://edu.chineserd.com/schoolInformation";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/schoolInformation";
      }
      window.open(url, "_blank");
    },
    homeToLogin() {
      let url = "https://edu.chineserd.com/";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/";
      }
      window.open(url, "_blank");
    },
    handleShowGuide(type, url) {
      this.showGuide = true;
      this.showType = type;
      this.guideUrl = url;
    },
    handleUploadVideo() {
      this.datumZZC = true;
    },
    datumYZ(e) {
      this.chooseFrom = e;
    },
    lianxi() {
      // 联系我们
      // window.location.href = 'http://wa.me/85291496563';
      window.open("http://wa.me/85291496563");
    },
    // 點擊上傳下一步
    datumBut(e) {
      switch (e) {
        case 0:
          // 下一步 驗證信息
          this.getUser();
          break;
        case 1:
          if (this.from2.school_name == null || this.from2.school_name == "") {
            this.$toast("请输入就讀學校 !");
            return;
          }

          if (this.from2.certificate == null || this.from2.certificate == "") {
            this.$toast("请上傳證件 !");
            return;
          }

          this.stepActive = 2;
          break;
        case 2:
          // 提交啦
          break;
        case 3:
      }
    },
    // 驗證信息
    getUser() {
      let params = {
        competitionType: 8,
      };
      if (this.chooseFrom == 0) {
        // 手機
        if (this.from2.phone == "" || this.from2.phone == null) {
          this.$toast("手機號格式有誤 !");
          return;
        }

        if (!this.validator_phone(this.from2.phone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }
        if (this.from2.name == "" || this.from2.name == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }

        params = {
          studentName: this.from2.name,
          prefix: this.prefix,
          phone: this.from2.phone,
          email: null,
        };
      } else if (this.chooseFrom == 1) {
        const { schoolCode, studentCode, password, name } = this.from2;
        // 判断三个参数不能为空
        if (schoolCode == "" || schoolCode == null) {
          this.$toast("請輸入學校編號 !");
          return;
        }
        if (studentCode == "" || studentCode == null) {
          this.$toast("請輸入登入編號 !");
          return;
        }
        if (name == "" || name == null) {
          this.$toast("請輸入參賽者姓名 !");
          return;
        }
        // if (password == "" || password == null) {
        //   this.$toast("請輸入學生密碼 !");
        //   return;
        // }

        params = {
          schoolCode,
          studentCode,
          password,
          studentName: name,
        };
      }

      this.datumActiveBut = false;
      this.$toast.loading();
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.$toast.clear();
          this.datumActiveBut = true;
          // console.log(response);
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.userObj.competitionGroup = response.data.data.competitionGroup; //組別
            this.userObj.score = response.data.data.score; //分數
            this.userObj.studentName = response.data.data.studentName; //名字

            if (response.data.data.shortlisted) {
              this.from2.school_name = response.data.data.school;
              this.schollName =
                response.data.data.school == ""
                  ? null
                  : response.data.data.school;
              // 成功
              if (this.chooseFrom == 0) {
                this.stepActive = 1;
              } else {
                this.stepActive = 2;
              }
            } else {
              // 失敗
              this.datumZZC = false; //复赛资料上传弹窗
              this.stepActive = 0; //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.$toast.clear();
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 視頻
    uploaderVideoChange(e) {
      // console.log('视频', e);
      this.from2.video = e.vaidoUrl;
      this.videoUrl = e.vaidoUrl;
      // this.videoUrl = e.yuanVideo;
      this.$toast.clear();
    },
    // 圖像
    uploaderImageChange(e) {
      // console.log('图像', e);
      this.from2.certificate = e.vaidoUrl;
      this.$toast.clear();
    },
    // 視頻預覽
    videoYLBut() {
      this.videoYL = !this.videoYL;
    },
    //返回上一步
    // getBack() {
    // 	this.stepActive--;
    //   this.from2.video = null
    //   this.videoUrl = null
    // },
    // 提交
    submit() {
      const {
        phone,
        name,
        video,
        email,
        certificate,
        school_name,
        schoolCode,
        studentCode,
        password,
      } = this.from2;
      let params = {
        // videoUrl: 'https://materialv3-1256597606.cos.ap-hongkong.myqc…/dev/2023-09/eb816d9e21e9f18fccea6c461ba2c3dc.mp4', //学生上传的视频内容
        videoUrl: video, //学生上传的视频内容
        // email, //學生電郵
        personalID: certificate,
        currentSchool: school_name,
        competitionType: 8,
      };
      if (this.chooseFrom == 1) {
        // 学校报名
        params.schoolCode = schoolCode;
        params.studentCode = studentCode;
        params.password = password;
      } else {
        // 个人报名
        params.phone = phone;
        params.studentName = name;
      }

      if (params.videoUrl == null || params.videoUrl == "") {
        this.$toast("請上傳參賽作品 !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading({
        message: "正在提交中...",
        duration: 0,
        forbidClick: true,
      });

      // 正式發包
      this.$axios
        .post(this.$api.update, params)
        .then((response) => {
          this.datumActiveBut = true;
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.$toast.clear();
            this.wonderful = true;
          }
        })
        .catch((error) => {
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 上傳成功  相當於初始化
    wonderfulBut() {
      this.wonderful = false;
      this.datumZZC = false;
      this.stepActive = 0;
      let from = {
        name: null,
        school_name: null,
        email: null,
        phone: null,
        certificate: null,
        video: null,
      };
      this.from2 = from;
    },
    zhangcheng() {
      window.open(
        this.currentCompetition === "1"
          ? this.rulesList[0].url
          : this.rulesList[1].url,
        "_blank"
      );

      // this.$toast.loading({
      // 	message: '獲取地址中...',
      // 	forbidClick: true,
      // 	duration: 0
      // });

      // let url = 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2023-07/fe62588d996ef0818389f65f4192086c.pdf';
      // this.$axios({
      //   url: url,
      //   method: 'get',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   this.$toast.clear();
      //   this.$toast.success('開始下載');
      //   // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   const downloadElement = document.createElement('a');
      //   const href = window.URL.createObjectURL(blob); // 创建下载链接
      //   downloadElement.href = href;
      //   downloadElement.download = 'zhangcheng.pdf'; // 文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 下载
      //   document.body.removeChild(downloadElement); // 下载完成后移除元素
      //   window.URL.revokeObjectURL(href); // 释放占用的内存空间
      // }).catch(error => {
      //   this.$toast.clear();
      //   console.error(error); // 处理异常情况
      // });
    },
    baoming() {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '報名未開始',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      if (this.currentCompetition === "1") {
        this.$router.push("/signup");
      } else {
        window.open(speecheduUrl, "_blank");
      }
    },
    socai() {
      if (this.currentCompetition === "1") {
        this.$router.push("/material");
      } else {
        window.open(
          "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/a9f0bce3cecc7699b4388f119042463e.pdf",
          "_blank"
        );
      }
    },
    stageBut(e) {
      this.competitionTimeLine.forEach((item, index) => {
        // console.log(item, index);
        if (index == e) {
          item.select = true;
        } else {
          item.select = false;
        }
      });
      // 触发滑动方法
      this.scrollLeftTo(e);
    },
    initScroll() {
      const target = document.getElementById('target');
      if (!target) return;
      const nav = this.$refs.timeSlide;
      // 获取 target 所在的 timeBox_list 父元素，用它的 offsetLeft 来计算
      const listItem = target.closest('.timeBox_list');
      const el = listItem || target;
      const to = el.offsetLeft - (nav.offsetWidth - el.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
    // 滑动
    scrollLeftTo(name) {
      const ref = `tab${name}Ref`;
      const nav = this.$refs.timeSlide;
      // console.log("额:", this.$refs.timeSlide.offsetWidth);
      const title = this.$refs[ref][0];
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-types {
  position: sticky;
  top: 0;
  width: 100%;
  margin-bottom: 30px;
  background: #d34a00;
  z-index: 99;
  .type-tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    .tab-item {
      min-width: 2rem;
      padding: 0.35rem 0.12rem;
      color: #fff;
      cursor: pointer;
      font-size: 0.32rem;

      &.active {
        font-weight: 600;
        color: #903300;
        background-image: url("~@/assets/image/hodgepodge/tabbuttom.png");
        background-size: 100% 100%;
        transform: scale(1.2);
      }
    }
  }
}

.awards-box {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 10px;
  box-sizing: border-box;
  overflow-x: auto; // 横向可滚动
  .awards-table-wrap {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #fa772f;
    font-size: 16px;
    line-height: 28px;
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #666;
    // 第一列的宽度固定100px
    td:first-child {
      width: 100px !important;
    }
    td {
      // width: 20%;
      border: 1px solid #fa772f;
      padding: 10px;
      vertical-align: middle;
      p {
        margin: 0 !important;
      }
      img {
        max-width: 150px;
        max-height: 150px;
      }
    }
    .award-item {
      /* 沿底部对齐 */
      position: relative;
      vertical-align: bottom;
    }
    tbody tr {
      background-color: #fdf4ec;
    }
  }
}

.table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 14px;
  line-height: 22px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666;

  th {
    border: 1px solid #fa772f;
    padding: 8px;
    font-weight: 600;
  }
  td {
    border: 1px solid #fa772f;
    padding: 8px;
    vertical-align: middle;
  }

  span {
    font-weight: 600;
  }
}

.table-tips {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #e80202;
  text-align: left;
  line-height: 1.2;
}

.score-box {
  .left-title {
    margin: 18px 0 10px 0;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #fa772f;
  }
  .table-wrap {
    margin-bottom: 15px;
  }
}

.views {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);

  .views_content {
    width: 100%;
    height: calc(100% - 0.92rem);
    overflow-x: hidden;

    .views_banner {
      width: 100%;
      display: grid;

      img {
        width: 100%;
      }
    }

    .views_uls {
      width: 100%;
      background: url("~@/assets/image/hodgepodge/back.png") no-repeat;
      background-size: 100%;
      min-height: 5rem;

      .back_box_uls {
        width: 100%;

        .backUls_box {
          width: 100%;
          padding: 0.32rem;
          box-sizing: border-box;

          .ulstitle {
            width: 6.0228rem;
            height: 0.43rem;
            margin: auto;

            img {
              width: 100%;
              margin-top: -0.85rem;
            }
          }

          .uls_list {
            width: 100%;
            background: #ffffff;
            padding: 0.32rem;
            box-sizing: border-box;
            background: #ffffff;
            box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.05);
            border-radius: 0.3rem;
            position: relative;

            .organizersMessage {
              width: 100%;
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              justify-content: space-between;
              gap: 0.25rem;
              margin-bottom: 0.25rem;
              .title_left {
                font-size: 0.24rem;
                line-height: 0.4rem;
                height: 0.4rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                text-align: left;
                margin-bottom: 5px;
              }
              img {
                width: 100%;
                background: #ffffff;
                border-radius: 6px;
                object-fit: contain;
                box-shadow: 0px 0.08rem 0.08rem 0px rgba(0, 0, 0, 0.03);
              }
              .text {
                font-size: 0.24rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                text-align: center;
                margin-top: 0.06rem;
                line-height: 1.3;
              }
            }
            .posters_text {
              width: 100%;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  margin-bottom: 0.16rem;
                  display: flex;
                  font-size: 0.24rem;
                  line-height: 0.4rem;

                  .posters_text_left {
                    width: 1.2rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    text-align: left;
                  }

                  .posters_text_right {
                    width: calc(100% - 1.5rem);
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    text-align: left;
                  }
                }
              }
            }
          }
        }

        .backUls_box2::-webkit-scrollbar {
          display: none;
        }

        .backUls_box2 {
          width: 100%;
          min-height: 3rem;
          margin-top: -18%;
          background: url("~@/assets/image/hodgepodge/back2.png") no-repeat;
          background-size: 100%;
          position: relative;
          padding-top: 2.6rem;
          padding-bottom: 0.86rem;
          padding-left: 0.32rem;
          box-sizing: border-box;
          overflow-x: scroll;

          .timeBox {
            width: 100%;
            height: 0.08rem;
            // background: linear-gradient(270deg, rgba(255,255,255,0) 0%, #FFFFFF 22%, #FFFFFF 80%, rgba(255,255,255,0) 100%);
            border-radius: 0.52rem;
            white-space: nowrap;
            // display: flex;
            display: inline-flex;
            margin-bottom: 1rem;

            .timeBox_list {
              width: 2.54rem;
              height: 100%;
              background: #ffffff;
              position: relative;
              flex: 0 0 auto;
              display: flex;
              justify-content: center;
              align-items: center;

              .timeBox_dian {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                border: 0.04rem solid #ffffff;
                border-radius: 50%;
              }

              .select {
                width: 0.32rem;
                height: 0.32rem;
                background: #ffe600;
              }

              .selectdefault {
                width: 0.2rem;
                height: 0.2rem;
                background: #ffffff;
              }

              .selectTime {
                padding: 0.1rem 0.3rem;
                font-size: 0.24rem;
                text-align: center;
                box-sizing: border-box;
                background: #f78040;
                border-radius: 50px;
                border: 1px solid #fff;
                color: #fff;
              }

              .timeBox_topselect {
                // border-image-source: url("~@/assets/image/icon/qipao2.png");
                // border-image-slice: 116 76 76 76;
                // border-image-width: 1.1rem 0.8rem 0.8rem 0.8rem;
                // border-width: 0.8rem;
                // padding: 0.07rem 0.17rem 0.14rem 0.17rem;
                // box-sizing: border-box;
                // font-size: 0.28rem;
                // font-family: PingFang SC-Semibold, PingFang SC;
                // font-weight: 600;
                // color: #903300 !important;
                // align-items:center !important;
              }

              .timeBox_top {
                width: 100%;
                height: 1rem;
                // background-color: red;
                position: absolute;
                bottom: 0.4rem;
                left: 0;

                display: flex;
                justify-content: space-around;
                align-content: flex-end;
                flex-wrap: nowrap;
                align-items: flex-end;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;

                img {
                  height: 100%;
                  object-fit: contain;
                }
              }

              .timeBox_bottom {
                width: 100%;
                height: 1rem;
                // background-color: red;
                position: absolute;
                top: 0.4rem;
                left: 0;

                display: flex;
                justify-content: space-around;
                font-size: 0.26rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.35rem;
              }
            }

            .timeBox_list:first-child {
              background: linear-gradient(
                270deg,
                #ffffff 80%,
                #ffffff 22%,
                #ffffff 80%,
                rgba(255, 255, 255, 0) 100%
              );
            }

            .timeBox_list:last-child {
              background: linear-gradient(
                270deg,
                rgba(255, 255, 255, 0) 0%,
                #ffffff 80%,
                #ffffff 80%,
                #ffffff 100%
              );
            }
          }
        }

        .backUls_box3 {
          width: 100%;
          background-color: #f78041;

          ul {
            width: 100%;
            display: flex;
            padding: 0.32rem;
            box-sizing: border-box;

            li {
              padding: 0.24rem;
              box-sizing: border-box;
              width: 100%;
              min-height: 2.72rem;
              background: #ffffff;
              box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.05);
              border-radius: 0.24rem;
              text-align: left;
              position: relative;

              .backUls_box3_list {
                width: 100%;
                font-size: 0.32rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #f97226;
                line-height: 0.43rem;
              }

              .backUls_box3_list2 {
                width: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 0.28rem;
                margin-top: 0.08rem;
                line-height: 0.44rem;

                span {
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  line-height: 0.28rem;
                  margin-top: 0.08rem;
                  line-height: 0.44rem;
                }
              }

              .backUls_box3_list3 {
                position: absolute;
                bottom: 0.24rem;
                right: 0.24rem;
                padding: 0.08rem 0.24rem;
                box-sizing: border-box;
                border-radius: 1.6rem;
                font-size: 0.24rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                line-height: 28px;

                background: url("~@/assets/image/hodgepodge/buttom.png")
                  no-repeat;
                background-size: 100% 100%;
                // background:#D0D0D0;
                box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
              }
            }
          }
        }

        .backUls_box4 {
          width: 100%;
          padding: 0.2rem;
          padding-top: 1.32rem;
          box-sizing: border-box;
          background: #ff782f;

          .backUls_box4_content {
            width: 100%;
            background-size: 100%;
            width: 100%;
            padding: 0.2rem;
            padding-top: 0rem;
            box-sizing: border-box;
            border-style: solid;
            border-width: 0.12rem;
            border-image-source: url("~@/assets/image/hodgepodge/back3.png");
            /* 使用 fill 让中间区域填充图片，不拉伸上下边；round 让侧边按整片平铺，避免长边拉伸导致变形 */
            /* 加大底部切片，完整包含圆弧，避免平铺拼接痕迹 */
            border-image-slice: 84 10 40 10 fill;
            /* 顶部/底部横线再加厚，避免横向看起来被压缩 */
            border-image-width: 0.76rem 0.12rem 0.54rem 0.12rem; /* top / right / bottom / left */
            /* 使用 stretch 避免 round 平铺在圆弧处出现接缝 */
            border-image-repeat: stretch;

            .ulstitle {
              width: 6.0228rem;
              height: 0.43rem;
              margin: auto;

              img {
                width: 100%;
                margin-top: -0.85rem;
              }
            }

            .backUls_box4_nr {
              width: 100%;
              min-height: 3rem;
              background: #ffffff;
              padding: 0.32rem 0.24rem 0.48rem 0.24rem;
              box-sizing: border-box;
              background: #ffffff;
              box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.05);
              border-radius: 0.16rem;
              position: relative;

              .backUls_box4_nr_list {
                font-size: 0.26rem;
                // font-family: PingFang SC-Semibold, PingFang SC;
                // font-weight: 600;
                // color: #f97226;
                // line-height: 0.44rem;
                // text-align: center;
                margin-bottom: 0.32rem;
                ul {
                  width: 100%;
                  padding: 0 0.2rem;
                  box-sizing: border-box;

                  li {
                    width: 100%;
                    font-size: 0.26rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #666666;
                    line-height: 0.44rem;
                    text-align: left;
                    // list-style: disc;
                  }
                }
                .cszg_table {
                  margin-top: 0.3rem;
                  .table-wrap {
                    width: 100%;
                    border-collapse: collapse;
                    border-spacing: 0;
                    border: 0.02rem solid #fa772f;
                    // font-size: 0.32rem;
                    line-height: 0.44rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #666;

                    th {
                      border: 0.02rem solid #fa772f;
                      padding: 0.2rem;
                      font-weight: 600;
                      vertical-align: middle;
                    }

                    td {
                      border: 0.02rem solid #fa772f;
                      padding: 0.2rem;
                      vertical-align: middle;
                    }

                    span {
                      font-weight: 600;
                    }
                  }
                }
                .isChinese {
                  /* 第一列 th/td 背景色 */
                  thead tr th:first-child,
                  tbody tr td:first-child {
                    background-color: #fddec5;
                  }

                  /* 第二列 td 背景色（同一色系，稍微加深一点也可以按需要调） */
                  tbody tr td:nth-child(2) {
                    background-color: #fddec5;
                  }

                  /* 最后一列 th/td 背景色 */
                  thead tr th:last-child,
                  tbody tr td:last-child {
                    background-color: #fddec5;
                  }
                }
              }

              .backUls_box4_remarks {
                width: 100%;
                font-size: 0.26rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 0.44rem;
              }
            }
          }
        }

        .backUls_box5 {
          width: 100%;
          padding: 0.2rem;
          padding-top: 1.32rem;
          box-sizing: border-box;
          background: #ff782f;

          .backUls_box5_content {
            width: 100%;
            background-size: 100%;
            width: 100%;
            padding: 0.2rem;
            padding-top: 0rem;
            box-sizing: border-box;
            border-style: solid;
            border-width: 0.12rem;
            border-image-source: url("~@/assets/image/hodgepodge/back3.png");
            /* 与 box4 保持一致的策略：中间区域填充，长边使用 round 平铺，避免 872px 高图在 3200px 时被强行拉伸 */
            border-image-slice: 84 10 40 10 fill;
            border-image-width: 0.76rem 0.12rem 0.54rem 0.12rem; /* top / right / bottom / left */
            border-image-repeat: stretch;

            .ulstitle {
              width: 6.0228rem;
              height: 0.43rem;
              margin: auto;

              img {
                width: 100%;
                margin-top: -0.85rem;
              }
            }

            .backUls_box5_nr {
              width: 100%;
              min-height: 3rem;
              background: #ffffff;
              padding: 0.32rem 0.24rem;
              box-sizing: border-box;
              background: #ffffff;
              box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.05);
              border-radius: 0.16rem;
              position: relative;

              .backUls_box5_nr_title {
                padding: 0.14rem 0.66rem;
                box-sizing: border-box;
                background: #ff9003;
                box-shadow: 0px 0px 0.14rem 0px rgba(249, 118, 47, 0.3);
                border-radius: 0.62rem;
                border: 0.04rem solid #ffffff;
                font-size: 0.32rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                display: inline-block;
                margin-bottom: 0.32rem;
              }

              .backUls_box5_nr_content {
                width: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #666666;
                line-height: 0.48rem;
                text-align: left;
                margin-bottom: 0.48rem;

                span {
                  color: #f97226;
                  font-weight: 600;
                }
              }

              .backUls_box5_nr_content:last-child {
                margin-bottom: 0px;
              }

              .backUls_box5_nr_content_2 {
                width: 100%;
                padding: 0;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #666666;
                line-height: 0.45rem;
                text-align: left;
                box-sizing: border-box;

                ol {
                  padding-left: 0.4rem;
                  list-style: decimal;
                  // list-style-position: inside;

                  li {
                    width: 100%;
                    // margin-bottom: 0.4rem;
                    display: list-item; // 确保使用列表项显示
                    // 如果以前有取消 marker 的规则（如 list-style: none），请删除或覆盖它

                    span {
                      color: #f97226;
                      font-weight: 600;
                    }

                    strong {
                      color: #e80202;
                      font-weight: 600;
                    }
                  }
                }

                .a_view {
                  text-align: center;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #e80202;
                  text-decoration: underline;
                }
              }

              .backUls_box5_nr_content_2:last-child {
                margin-bottom: 0px;
              }

              .backUls_box5_nr_content_3 {
                width: 100%;

                .backUls_box5_nr_content_3_view1 {
                  min-height: 2.82rem;
                  padding: 0.32rem;
                  box-sizing: border-box;
                  background: #fff6f1;
                  border-radius: 0.16rem;
                  border: 0.04rem solid #fed011;
                  position: relative;
                  margin-bottom: 0.48rem;

                  h1 {
                    width: 100%;
                    display: flex;
                    font-size: 0.28rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #f97226;
                    line-height: 0.36rem;

                    span {
                      color: #ff8f03;
                      margin-left: 0.2rem;
                      font-weight: 500;
                      font-size: 0.24rem;
                    }
                  }

                  ul {
                    width: 100%;
                    margin-top: 0.24rem;
                    padding-left: 0.48rem;
                    box-sizing: border-box;

                    li {
                      width: 100%;
                      font-size: 0.24rem;
                      font-family: PingFang SC-Semibold, PingFang SC;
                      color: #666666;
                      line-height: 0.28rem;
                      text-align: left;
                      // list-style: disc;
                      font-weight: 400;
                      margin-bottom: 0.24rem;
                    }
                  }

                  .jinpai {
                    width: 1.66rem;
                    position: absolute;
                    right: -0.35rem;
                    bottom: 0;

                    img {
                      width: 100%;
                    }
                  }

                  .jiangbei {
                    width: 1.66rem;
                    position: absolute;
                    right: -0.35rem;
                    bottom: -0.1rem;

                    img {
                      width: 100%;
                    }
                  }
                }

                .backUls_box5_nr_content_3_view2 {
                  min-height: 1.96rem;
                  background: #fff6f1;
                  border-radius: 0.08rem;
                  border: 0.01rem solid #fa772f;
                  position: relative;
                  margin-bottom: 0;
                  display: flex;

                  .lists {
                    width: 2.44rem;
                    font-size: 0.24rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    color: #f97226;
                    line-height: 0.33rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-right: 0.01rem solid #fa772f;
                  }

                  .lists2 {
                    width: calc(100% - 2.44rem);

                    ul {
                      width: 100%;
                      height: 100%;
                      padding-left: 0.48rem;
                      box-sizing: border-box;
                      display: flex;
                      flex-wrap: wrap;
                      align-items: center;
                      align-content: center;

                      li {
                        width: 100%;
                        font-size: 0.24rem;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        color: #666666;
                        line-height: 0.28rem;
                        text-align: left;
                        // list-style: disc;
                        font-weight: 400;
                        margin-bottom: 0.24rem;
                      }
                    }
                  }
                }

                .bo_color {
                  background: #fffce8 !important;
                  border: 0.04rem solid #fed011 !important;
                }

                .bo_color2 {
                  background: #f9fcff !important;
                  border: 0.04rem solid #d1e1ee !important;
                }
                .bo_color3 {
                  background: #fff4ee !important;
                  border: 0.04rem solid #fa772f !important;
                }
              }

              .backUls_box5_nr_content_3:last-child {
                margin-bottom: 0px;
              }
              .guidance-table-wrap {
                width: 100%;
                border-collapse: collapse;
                border-spacing: 0;
                border: 1px solid #fa772f;
                font-size: 0.26rem;
                line-height: 0.4rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #1a1a1a;
                table-layout: fixed;

                // 如果之前有 th, td { width: 20%; } 建议去掉，避免再撑宽
                // th,
                // td {
                //   width: 20%;
                //   box-sizing: border-box;
                // }

                td {
                  border: 1px solid #fa772f;
                  padding: 0.2rem;
                  vertical-align: middle;
                  word-wrap: break-word;
                  word-break: break-word;
                  p {
                    margin: 0 !important;
                  }
                }

                /* 新增：表格内部图片尺寸约束 */
                img {
                  max-width: 100%; // 不超过单元格宽度
                  height: auto; // 按比例缩放
                  max-height: 1.4rem; // 给一个相对合理的高度（按你页面风格，可微调）
                  display: block;
                  margin: 0 auto; // 居中
                  object-fit: contain; // 保持完整显示，不裁切
                }

                .app_login {
                  display: inline-block;
                  margin-bottom: 0.2rem;
                  img {
                    width: 1rem;
                    height: auto;
                    max-height: none; // 保持原先小图标大小，不被上面的 max-height 限制
                  }
                }

                tbody tr:nth-child(-n + 5) {
                  background-color: #fdf4ec;
                }
                tbody tr:nth-child(n + 6):nth-child(-n + 6) {
                  background-color: #fddec5;
                }
                tbody tr:nth-child(n + 7):nth-child(-n + 10) {
                  background-color: #f5bd8c;
                }
              }

              .materials-table-wrap {
                width: 100%;
                border-collapse: collapse;
                border-spacing: 0;
                border: 1px solid #fa772f;
                font-size: 16px;
                line-height: 28px;
                font-family: PingFang SC-Semibold, PingFang SC;
                color: #666;
                margin-top: 20px;
                td {
                  width: 50%;
                  border: 1px solid #fa772f;
                  padding: 10px;
                  vertical-align: middle;
                }
                // tbody tr {
                //   background-color: #fdf4ec;
                // }
              }
            }
          }
        }

        .backUls_box6 {
          width: 100%;
          padding: 0.32rem;
          padding-top: 1.32rem;
          box-sizing: border-box;
          background: #ff782f;
        }
      }
    }
    .fontBottom {
      height: 1.2rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      /* 关闭入口 */
      // padding: 0.16rem 0.32rem 0.1rem 0.32rem;
      // box-sizing: border-box;
      // background: rgba(255, 129, 57, 0.28);
      // background:#D0D0D0;
      // backdrop-filter: blur(15px);
      // -webkit-backdrop-filter: saturate(180%) blur(15px);
      /* 报名 */
      background: url("~@/assets/image/icon/bottom_btn.png") no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 101;

      img {
        max-height: 0.9rem;
      }

      span {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        font-size: 0.48rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .datumBox {
    width: 90vw;
    max-width: 12rem;
    // width: 330px;
    // height: 308px;
    padding-top: 0.48rem;
    padding-bottom: 0.48rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.32rem;

    .titleH1 {
      width: 100%;
      font-size: 0.36rem;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 0.16rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.22rem;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 0.04rem;
          background-color: #ff5a25;
          margin-left: 0.14rem;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 0.12rem;
          height: 0.12rem;
          border-radius: 0.06rem;
          background-color: #ff5a25;
          margin-left: 0.14rem;
        }
        div:first-child {
          display: inline-block;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.08rem;
          background-color: #ff5a25;
          margin-left: 0.14rem;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 0.04rem;
          background-color: #ff5a25;
          margin-right: 0.14rem;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 0.12rem;
          height: 0.12rem;
          border-radius: 0.06rem;
          background-color: #ff5a25;
          margin-right: 0.14rem;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.08rem;
          background-color: #ff5a25;
          margin-right: 0.14rem;
        }
      }
    }

    .stepBox {
      width: 55%;
      margin: auto;
      position: relative;

      .stepUls {
        width: 100%;
        height: 0.6rem;
        display: flex;

        .xian {
          width: 50%;
          height: 100%;
          position: relative;
        }

        .active {
          position: relative;
        }

        .active:after {
          content: " ";
          width: 100%;
          height: 0.05rem;
          background: #f5f5f5;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }

        .active2:after {
          content: " ";
          width: 100%;
          height: 0.05rem;
          background: #ff5a25;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      ul {
        width: 100%;
        height: 0.6rem;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          background-color: #ff5a25;
          position: relative;

          div {
            position: absolute;
            bottom: -10%;
            font-size: 0.24rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #cccccc;
          }
        }

        .active {
          width: 0.38rem;
          height: 0.38rem;
          border-radius: 50%;
          background: url("~@/assets/image/fusai/dui.png") no-repeat;
          background-size: 100%;
        }
      }
    }

    .stepText {
      width: 70%;
      margin: auto;
      height: 0.6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
      }
      div:nth-child(1) {
        margin-left: 9%;
      }

      div:nth-child(2) {
        margin-left: 16%;
      }

      div:nth-child(3) {
        margin-left: 10%;
      }
      .active {
        color: #de2810 !important;
      }
    }

    .datumCentent {
      width: 80%;
      margin: auto;
      margin-top: 0.3rem;

      .tab {
        width: 100%;
        text-align: left;
        margin-bottom: 0.2rem;

        .prompt {
          height: 0.5rem;
          font-size: 0.28rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          line-height: 10px;
          // margin-bottom: 12px;
          // padding-left: 13px;
          // box-sizing: border-box;
          display: flex;

          div {
            margin-right: 0.22rem;
            text-align: center;
            line-height: 0.4rem;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 0.196rem !important;
            color: #de2810;
            margin-left: 0.1rem;
          }
        }

        .lis {
          width: 100%;
          height: 0.68rem;
          line-height: 0.68rem;
          background: #f5f5f5;
          display: flex;
          justify-content: space-between;
          border-radius: 6px;

          .lisLife {
            display: flex;
            align-items: center;
            font-size: 0.26rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #4a4a4a;
            box-sizing: border-box;
            width: 1.8rem;
            padding-left: 0.2rem;
            img {
              width: 0.32rem;
              height: 0.22rem;
              margin-right: 0.1rem;
            }
          }

          .lisRight {
            width: calc(100% - 1.9rem);
            height: 100%;
            display: flex;
            input {
              font-size: 0.32rem;
              width: 100%;
              height: 0.68rem;
              padding-left: 0.06rem;
              box-sizing: border-box;
              border: none;
              background: #f5f5f5;
              font-size: 0.28rem;
              font-family: PingFang SC-Regular, PingFang SC;
            }
            input::-webkit-input-placeholder {
              color: #999999;
            }
            /* 使用webkit内核的浏览器 */
            input:-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本4-18 */
            input::-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本19+ */
            input:-ms-input-placeholder {
              color: #999999;
            } /* IE浏览器 */
          }
        }

        .row-input {
          display: flex;
          align-items: center;
          font-size: 0;
          margin-bottom: 0.24rem;
        }
        .input-name {
          width: 25%;
          // height: 30px;
          font-size: 0.28rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          padding-left: 0.26rem;
        }
        .promptInput {
          width: 100%;
          // width: 75%;
          height: 0.68rem;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 0.06rem;
          display: flex;
          align-items: center;
          input {
            width: 100%;
            height: 100%;
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 0.06rem;
            border: none;
            padding-left: 0.26rem;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          // width: 75%;
          height: 0.68rem;
          line-height: 0.68rem;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 0.12rem;
          // margin-bottom: 12px;
          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 0.26rem;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 0.12rem;
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }

        .promptInput3 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background-color: #f7f8fa;
          height: 2.6rem;
          border: 3px dotted #f5f5f5;
          position: relative;

          .wonderful {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 0.24rem;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #4d4d4d;

            img {
              width: 0.8rem;
              height: 0.8rem;
              border-radius: 1rem;
              margin-bottom: 0.6rem;
            }
          }

          .videoYulan {
            width: 100%;
            height: 100%;
            z-index: 999999;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            video {
              width: 80%;
              // object-fit: cover;
              height: 100%;
            }

            .guanbu {
              position: absolute;
              top: 5%;
              right: 5%;
              width: 0.4rem;
              height: 0.4rem;
              color: #fff;
              font-size: 0.24rem;
              z-index: 999;
              border-radius: 1rem;
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .videoYulan2 {
            position: absolute;
            bottom: 0.06rem;
            right: 0px;
            left: 0px;
            margin: auto;
            font-size: 0.24rem;
            color: #ff5a25;
            text-align: center;
            width: 100%;
          }
        }
      }

      .tabTis {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.24rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 0.4rem;
        margin-bottom: 1rem;

        img {
          width: 0.6rem;
          height: 0.6rem;
          margin-left: 0.2rem;
        }
      }
      .tabTis_1 {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.24rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 0.4rem;
        // margin-bottom: 50px;

        img {
          width: 0.6rem;
          height: 0.6rem;
          margin-left: 0.2rem;
        }
      }
      .view_guide {
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5a25;
        text-decoration: underline;
      }
      .but {
        width: 2.8rem;
        height: 0.8rem;
        background: url("~@/assets/image/but.png") no-repeat;
        background-size: 100%;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.28rem;
        font-weight: bold;
        color: #fff;
        margin: auto;
        margin-top: 0.4rem;
      }

      .but2 {
        width: 2.8rem;
        height: 0.6rem;
        text-align: center;
        font-size: 0.28rem;
        color: #4d4d4d;
        margin: auto;
        margin-top: 0.2rem;
      }
    }
  }
}
.newShortBox {
  width: 6.6rem;
  // height: 308px;
  padding-top: 0.48rem;
  padding-bottom: 0.48rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.32rem;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    .lis {
      width: 100%;
      margin-bottom: 0.4rem;

      img {
        width: 2.98rem;
      }
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: auto;
      font-size: 0.28rem;

      div {
        p {
          margin-bottom: 10px;
        }
      }

      span {
        color: #ff5a25;
      }
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ulst {
      width: 86%;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 0.06rem;

        li {
          width: 33.3%;
          text-align: center;
          font-size: 0.24rem;
        }
        li:nth-child(2) {
          width: 30% !important;
        }
      }

      ul:nth-child(1) {
        background: #ff5a25;
        height: 0.6rem;
        line-height: 0.6rem;

        li {
          height: 100%;
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        font-size: 0.196rem !important;
        line-height: 0.4rem;
        margin-top: 0.2rem;
        margin-bottom: 0.4rem;

        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      font-size: 0.28rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 0.48rem;
      padding-right: 0.5rem;
      padding-left: 0.5rem;
      box-sizing: border-box;
    }

    .but {
      width: 2.8rem;
      height: 0.8rem;
      background: url("~@/assets/image/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 0.72rem;
      font-size: 0.28rem;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
.show-link {
  color: #f97226;
  font-weight: 400 !important;
  text-decoration: underline;
}
.link_not_allowed {
  color: #999999;
  font-weight: 400 !important;
  text-decoration: none;
  cursor: not-allowed;
}

.image-container {
  max-height: 78vh;
  overflow-y: auto;
}
.van-dialog {
  top: 54%;
  background-color: #000;
}

.bxxq-table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 0.32rem;
  line-height: 0.56rem;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #1a1a1a;
  td {
    border: 1px solid #fa772f;
    padding: 0.2rem;
    vertical-align: top;
    p {
      margin: 0 !important;
      color: #1a1a1a !important;
    }
  }
  tbody tr:nth-child(-n + 2) {
    background-color: #fdf4ec;
  }
  tbody tr:nth-child(n + 3) {
    background-color: #fddec5;
  }
  // 第一个tr的第一个td
  tbody tr:first-child td:first-child {
    font-weight: 600;
    width: 30px;
    text-align: center;
    vertical-align: middle;
  }

  // 第一个tr的第二个td
  tbody tr:first-child td:nth-child(2) {
    width: calc((100% - 30px) / 2);
    box-sizing: border-box;
  }
  // 第一个tr的第三个td
  tbody tr:first-child td:last-child {
    width: calc((100% - 30px) / 2);
    box-sizing: border-box;
  }
}
</style>
